import React from 'react';
import { Checkbox as AntCheckbox } from 'antd';
import { CheckboxProps as AntCheckboxProps } from 'antd/lib/checkbox';

import useComponentConfiguration from 'DisplayFramework/useComponentConfiguration';

export type CheckboxProps = Omit<AntCheckboxProps, 'children'> & {
  comcode: string;
  withoutLabel?:Boolean
};

const Checkbox = ({ comcode,withoutLabel, ...otherProps }: CheckboxProps) => {
  const { isDisabled, label } = useComponentConfiguration(comcode);

  return (
    <AntCheckbox disabled={isDisabled} {...otherProps}>
      {!withoutLabel&&label}
    </AntCheckbox>
  );
};

export default Checkbox;
